import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import AddShoppingCartOutlinedIcon from '@mui/icons-material/AddShoppingCartOutlined';
import AddCircleTwoToneIcon from '@mui/icons-material/AddCircleTwoTone';
import {
  Popover,
  Box,
  Typography,
  Button,
  Grid,
  Skeleton,
  useTheme,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import restype from "../../assets/restype.png";
import {
  setExtraProductData,
  setGuestCount,
  setIsBackToHoreca,
  setQuantities,
  setSelectedExtraProduct,
  updateReservationGroup,
  updateReservationType,
  updateSelectedDate,
  updateTime,
  updateTotalCount,
} from "../../store/slice/Addguest.slice";
import { getExtraProductDetails } from "../../api/HorecaWidget.service";
import ShowMoreLessText from "./ShowMoreLessText";
import { format_Number } from "../../utils/utils";

const ReservationType = ({ Ref, isOpen, handleClose, isLoading }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery("sm");
  const popoverRef = useRef(null);
  const [popoverPosition, setPopoverPosition] = useState({
    vertical: "bottom",
    horizontal: "center",
  });
  const [showMore, setShowMore] = useState(false);
  const [isImageValid, setIsImageValid] = useState(true); // Track image validity
  const matchesXs = useMediaQuery(theme.breakpoints.down("xs")); // For small devices
  const matchesSm = useMediaQuery(theme.breakpoints.down("sm")); // For tablets and up
  const {
    totalCount,
    reservationTypeDatas,
    reservType,
    time,
    reservGroup,
    selectedExtraProduct,
    quantities,
    isBackToHoreca,
    languageId,
    defaultLanguage,
    languageWords,
    tot,
  } = useSelector((store) => store?.addGuest);
  const { widgetConfig } = useSelector((store) => store?.widgetSettings);
  const { defaultLang } = useSelector((store) => store?.Combination);
  const dispatch = useDispatch();

  const fetchExtraProducts = async () => {
    try {
      const response = await getExtraProductDetails(
        reservType?.idreservationtype,
        defaultLang ? defaultLang : defaultLanguage
      );
      if (response?.status != 200 || !response?.data) {
        throw new Error(
          "Could not fetch extra product details for reservation type " +
            response
        );
      }
      dispatch(setExtraProductData(response?.data));
    } catch (error) {
      console.error("error extra product", error?.message);
    }
  };

  useEffect(() => {
    if (reservType?.idreservationtype != null && !isBackToHoreca) {
      fetchExtraProducts();
    }
  }, [reservType?.idreservationtype, isBackToHoreca, defaultLanguage]);

  useEffect(() => {
    if (reservationTypeDatas?.length === 1) {
      dispatch(updateReservationType(reservationTypeDatas[0]));
    }
  }, [reservationTypeDatas]);

  return (
    <Popover
      open={isOpen}
      anchorEl={Ref}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: matchesSm ? "93%" : "100%",
          maxWidth: "850px",
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: theme?.resType?.bgColor,
          width: { xs: "100%", sm: "100%", md: "100%" }, // Responsive width
          p: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        {isLoading ? (
          // Shimmer loading effect
          Array.from(new Array(3)).map((_, i) => (
            <Box
              key={i}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "column", md: "row" },
                gap: "0.5rem",
                backgroundColor: "#EBEBEB",
                border: "1px solid #EBEBEB",
                p: 1,
                borderRadius: "8px",
                width: { xs: "100%", sm: "100%", md: "100%" }, // Dynamic width for responsiveness
              }}
            >
              <Grid container>
                <Grid item xs={12} sm={12} md={4}>
                  <Skeleton variant="rectangular" height={110} />
                </Grid>
                <Grid item xs={12} sm={12} md={8}>
                  <Box sx={{ p: 1, width: "100%" }}>
                    <Skeleton />
                    <Skeleton width="60%" />
                    <Skeleton width="80%" />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          ))
        ) : reservationTypeDatas?.length <= 0 ? (
          <Typography
            variant="body2"
            sx={{ textAlign: "center", color: "grey", fontWeight: "medium" }}
          >
            No reservation type available.
          </Typography>
        ) : (
          reservationTypeDatas.map((item, i) => {
            const nameTranslation = item.reservationtypeLanguages.find(
              (lang) =>
                lang.fieldname === "name" && lang.idlanguage === languageId
            );
            const infoTranslation = item.reservationtypeLanguages.find(
              (lang) =>
                lang.fieldname === "info" && lang.idlanguage === languageId
            );

            return (
              <Box
                key={i}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "row" }, // Responsive flexDirection
                  gap: "0.5rem",
                  backgroundColor:
                    reservType?.name === item?.name
                      ? theme?.resType?.itemBgActive
                      : theme?.resType?.itemBgColor,
                  border: `1px solid ${theme?.resType?.borderColor}`,
                  p: 2,
                  borderRadius: "8px",
                  cursor: "pointer",
                  color:
                    reservType?.name === item?.name
                      ? theme?.resType?.textColorActive
                      : theme?.resType?.itemTextColor,
                  width: "100%", // Adjust width for small screens
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.02)",
                    boxShadow: "0px 6px 18px rgba(0,0,0,0.2)",
                  },
                  
                }}
              >
                <Grid container spacing={1} sx={{ position: "relative" }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      alignItems: "center",

                      //p: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontWeight: "600",
                        ml:2
                      }}
                    >
                      {nameTranslation?.data || item?.name}
                    </Typography>
                    {item?.totalCost > 0 &&
                      totalCount < widgetConfig?.reservationRequestMin && (
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: "600",
                          }}
                        >
                          €{format_Number(parseFloat(item?.totalCost).toFixed(2))}
                        </Typography>
                      )}
                  </Box>
                {item?.imageFileName && isImageValid && ( 
                    <Grid item xs={12} sm={4} md={4}>
                      <Box
                        sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                borderRadius: "12px",
                overflow: "hidden", // To ensure image doesn't overflow
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)", // Subtle shadow around image
                "&:hover img": {
                  transform: "scale(1.05)", // Slight zoom effect on hover
                  transition: "transform 0.3s ease-in-out"
                }
                        }}
                      >
                        <img
                         src={item?.imageFileName}
                             // src={ 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXrv0guyz9eApxe0bSXh6bHl7z_HQZSE6G9g&s'}
                          alt="res-type-img"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: "8px",
                transition: "transform 0.3s ease-in-out",
              }}

                          onLoad={() => {
                            setIsImageValid(true); // Confirm valid image
                          }}
                          onError={(error) => {
                            setIsImageValid(false); // Mark image as invalid
                          }}
                        />
                      </Box>
                    </Grid>
                     )}   


        
                
                  <Grid
                    item
                    xs={12}
                    sm={item?.imageFileName && isImageValid ? 8 : 12}
                    md={item?.imageFileName && isImageValid ? 8 : 12}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        //  minHeight: "20px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      {item?.info && (
                        <ShowMoreLessText
                          text={infoTranslation?.data || item?.info}
                          setIsShowMore={() => setShowMore(!showMore)}
                          isShowMore={showMore}
                        />
                      )}

                       <Box
                        sx={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                          mt: "auto", // Pushes the button to the bottom
                          position: item?.totalCost > 0 ?  "relative" : "absolute",
                          bottom: 0,

                          right: 0,
                        }}
                      >
                        <IconButton
                         
                          size="small"
                          sx={{
                            backgroundColor:
                              reservType?.name === item?.name
                                ? theme?.resType?.chooseBgActive
                                : theme?.resType?.chooseBg,
                            color:
                              reservType?.name === item?.name
                                ? theme?.resType?.chooseTextActive
                                : theme?.resType?.chooseText,
                            "&:hover": {
                              backgroundColor: theme?.resType?.chooseBgHover,
                              color: theme?.resType?.chooseTextHover,
                            },
                            // width: "60px",
                            // height: "30px",
                            // fontSize: "10px",
                            borderRadius: "7px",
                          }}
                          onClick={() => {
                            dispatch(setIsBackToHoreca(false));
                            if (selectedExtraProduct?.length > 0) {
                              dispatch(setSelectedExtraProduct([]));
                            }
                            if (Object?.keys(quantities)?.length > 0) {
                              dispatch(setQuantities({}));
                            }
                            if (
                              reservGroup &&
                              Object?.keys(reservGroup)?.length > 0
                            ) {
                              dispatch(updateReservationGroup({}));
                            }
                            if (time?.trim() !== "") {
                              dispatch(updateTime(""));
                            }
                            localStorage?.setItem('idreservation',null)
                            dispatch(updateReservationType(item));
                            handleClose();
                          }}
                        >
                           <AddCircleTwoToneIcon />
                        </IconButton>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            );
          })
        )}
      </Box>
    </Popover>
  );
};

export default ReservationType;
